import React, { useState, useEffect, useRef } from "react";
import { useLocation, useNavigate, Link } from "react-router-dom";
import Grocerymanagement from "../Grocery/orderpages/Grocerymanagement";
import Groceryorder from "../Grocery/orderpages/Groceryorder";
import Grocerymobileorders from "../Grocery/orderpages/Grocerymobileorders";
// import '.\Ordermanagment.css'
const Groceryordermanagment = () => {

    const [activeCategory, setActiveCategory] = useState("Overview");

    const isMobile = window.innerWidth <= 768;


    return (
        <div>
            {/* Breadcrumb */}


            <div className="container-fluid">
                <div className="row">
                    <div className="row" style={{ marginTop: "40px" }}>
                        {/* Left Column */}
                        <div className="col-lg-2 order-management-data">
                            <Grocerymobileorders />
                        </div>

                        {/* Middle Column */}
                        <div
                            className="col-lg-7 col-md-7 col-sm-12 col-12 "
                            style={{ paddingLeft: "0px", paddingRight: "0px" }}
                        >
                            <p
                                className="breadcrumb maamaas-home-bredcum"
                                style={{
                                    position: "fixed",
                                    top: isMobile ? "50px" : "80px",
                                    left: isMobile ? "5px" : "275px",
                                    width: "100%",
                                    backgroundColor: "#fff",
                                    zIndex: 1000,
                                    padding: "10px 0",
                                    fontSize: isMobile ? "14px" : "18px",
                                    fontWeight: isMobile ? "normal" : "bold",
                                    textAlign: "center",
                                    margin: 0,
                                }}
                            >
                                <Link
                                    to="/Newmainlandingpage"
                                    style={{ color: "purple", fontWeight: "bold", textDecoration: "none" }}
                                >
                                    Home
                                </Link>
                                <span className="separator"> &gt; </span>
                                <Link
                                    to="/foodladingpage"
                                    style={{ color: "purple", fontWeight: "bold", textDecoration: "none" }}
                                >
                                    Fresh & Groceries
                                </Link>
                                <span className="separator"> &gt; </span>
                                <Link

                                    style={{ color: "purple", fontWeight: "bold", textDecoration: "none" }}
                                >
                                    Order_Management
                                </Link>

                            </p>
                            <div style={{ borderRadius: "8px" }} className="order-management-data">
                                {activeCategory === "Overview" && <Grocerymanagement />}
                                {/* {activeCategory === "Closed" && <Closed />}
                                {activeCategory === "Pending" && <Pending />}
                                {activeCategory === "Food" && <Food />} */}
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            {/* Right Column */}
            <div className="col-lg-3">
                <Groceryorder />
            </div>
        </div>
    );
};

export default Groceryordermanagment;
